import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Cursor from "@/components/site/Cursor";
import { LenisProvider } from "@/lib/lenis";

function App() {
  useEffect(() => {
    document.title = "Nsoul Ventures — Procurement, Supply, Interiors & Project Execution";
  }, []);

  return (
    <div className="App">
      <LenisProvider>
        <Cursor />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </LenisProvider>
    </div>
  );
}

export default App;
